export default __webpack_public_path__ + "static/media/facebook (1).08465fd9.svg";